import './index.css';

export default {
  name: 'Aselect',
  props: {
    value: { type: null, default: () => null },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  data() {
    return {
      model: this.value,
    }
  },
  watch: {
    value(value) {
      this.model = value;
    },
  },
  computed: {
    array() {
      return this.options || this.option || this.config || this.items || this.data || [];
    },
    smart() {
      const a = this.$attrs;
      const smart = (a.shortcuts || a.shortcut || a.quickly || a.quick || a.smart || a.fast || a.all);
      return smart !== undefined ? smart : true;
    },
    checked: {
      get() { return this.value && ((this.value.length > 0) && (this.value.length === this.array.length)) },
      set(checked) { this.$emit('update', { checked }) },
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
    change(value) {
      this.$emit('change', value, this.filter(value));
    },
    choose(checked) {
      const data = [];
      if (checked) {
        this.data.forEach((a, b) => data[b] = (`${a.values || a.value || a.code || a.val || a.id || a}`));
        this.change(data);
      }
      this.model = data;
      this.$emit('input', data);
    },
    filter(value = '') {
      if (value && value !== '') {
        let data = {};
        this.array.forEach(a => {
          const index = (`${a.values || a.value || a.code || a.val || a.id || a}`);
          if (value === index) data = a;
        });
        return data;
      }
    },
  },
  render() {
    const { size = 'small', ...r } = this.$attrs;
    const attrs = { clearable: true, filterable: true, collapseTags: true, ...r };
    const { ...on } = this.$listeners;
    return (
      <el-select class="a-select" popper-class="a-select-popper" size={size} v-model={this.model} {...{ attrs }} {...{ on }} on-input={this.input} on-change={this.change}>
        {this.array.length > 0 && r.multiple && this.smart && (
          <li key="all" class={['el-select-dropdown__item', (this.checked ? 'selected' : null), 'a-select-option']}>
            <el-checkbox v-model={this.checked} on-change={this.choose}>全部</el-checkbox>
          </li>
        )}
        {this.array.length > 0 && this.array.map((a, b) => {
          const label = a.label || a.title || a.text || a.name || a.key || a;
          const value = (`${a.value || a.code || a.val || a.id || a}`);
          return (<el-option key={b} label={label} value={value} class="a-select-option" />);
        })}
      </el-select>
    );
  }
}